<nz-page-header *ngIf="product" [nzTitle]="'Edit Product ' + product.name"></nz-page-header>
<nz-page-header *ngIf="!product" nzTitle="Create Product"></nz-page-header>

<form nz-form [formGroup]="form" *ngIf="form" nzLayout="vertical" class="product-form">
	<nz-tabset (nzSelectedIndexChange)="selectedTab=$event">

		<!-- ─── Basic Details ───────────────────────────────────────────────── -->
		<nz-tab nzTitle="Basic Details">
			<div class="row">
				<div class="col-4">
					<nz-form-item>
						<nz-form-label nzRequired>Name</nz-form-label>
						<nz-form-control nzErrorTip="Please enter a product name">
							<input nz-input formControlName="name" />
						</nz-form-control>
					</nz-form-item>

					<div class="row">
						<div class="col">
							<nz-form-item>
								<nz-form-label nzRequired>Product Type</nz-form-label>
								<nz-form-control nzErrorTip="Please select a product type">
									<nz-select formControlName="productType">
										<nz-option *ngFor="let item of availableProductTypes" [nzValue]="item" [nzLabel]="item" [nzDisabled]="product?.id"></nz-option>
									</nz-select>
								</nz-form-control>
							</nz-form-item>
						</div>
						<div class="col">
							<nz-form-item>
								<nz-form-label nzRequired>Benefit Type</nz-form-label>
								<nz-form-control nzErrorTip="Please select a benefit type">
									<nz-select formControlName="benefitType">
										<nz-option *ngFor="let item of availableBenefitTypes" [nzValue]="item" [nzLabel]="item"></nz-option>
									</nz-select>
								</nz-form-control>
							</nz-form-item>
						</div>
					</div>

					<nz-form-item>
						<nz-form-label>Description</nz-form-label>
						<nz-form-control>
							<div class="description-wrapper">
								<textarea nz-input rows="4" formControlName="description"></textarea>
							</div>
						</nz-form-control>
					</nz-form-item>
				</div>

				<div class="col-4">
					<nz-form-item>
						<nz-form-label nzRequired>Lapsed Premium Window (Months)</nz-form-label>
						<nz-form-control nzErrorTip="Please enter a value">
							<input nz-input type="number" formControlName="lapsedPremiumWindowInMonths" />
						</nz-form-control>
					</nz-form-item>

					<nz-form-item>
						<nz-form-label nzRequired>Max Allowed Lapsed premiums in Window period (Months)</nz-form-label>
						<nz-form-control nzErrorTip="Please enter a value">
							<input nz-input type="number" formControlName="maxAllowedLapsedPremiumsInWindowPeriod" />
						</nz-form-control>
					</nz-form-item>

					<nz-form-item>
						<nz-form-label nzRequired>Max Allowed Consecutive Lapsed Premiums</nz-form-label>
						<nz-form-control nzErrorTip="Please enter a value">
							<input nz-input type="number" formControlName="maxAllowedConsecutiveLapsedPremiums" />
						</nz-form-control>
					</nz-form-item>
					<nz-form-item>
						<nz-form-label nzRequired>Premium Split Payment Day of Month</nz-form-label>
						<nz-form-control nzErrorTip="Premium Split Payment Day of Month">
							<input nz-input type="number" formControlName="premiumSplitPaymentDayOfMonth" min="1" max="31" />
						</nz-form-control>
					</nz-form-item>
					<nz-form-item>
						<nz-form-label nzRequired>Raise Premium Day of Month</nz-form-label>
						<nz-form-control nzErrorTip="Raise Premium Day of Month">
							<input nz-input type="number" formControlName="raisePremiumDayOfMonth" min="1" max="31" />
						</nz-form-control>
					</nz-form-item>
					<nz-form-item>
						<nz-form-label nzRequired>Review Month</nz-form-label>
						<nz-form-control nzErrorTip="Review Month">
							<nz-select nzAllowClear formControlName="reviewMonth">
								<nz-option [nzValue]="1" nzLabel="January"></nz-option>
								<nz-option [nzValue]="2" nzLabel="February"></nz-option>
								<nz-option [nzValue]="3" nzLabel="March"></nz-option>
								<nz-option [nzValue]="4" nzLabel="April"></nz-option>
								<nz-option [nzValue]="5" nzLabel="May"></nz-option>
								<nz-option [nzValue]="6" nzLabel="June"></nz-option>
								<nz-option [nzValue]="7" nzLabel="July"></nz-option>
								<nz-option [nzValue]="8" nzLabel="August"></nz-option>
								<nz-option [nzValue]="9" nzLabel="September"></nz-option>
								<nz-option [nzValue]="10" nzLabel="October"></nz-option>
								<nz-option [nzValue]="11" nzLabel="November"></nz-option>
								<nz-option [nzValue]="12" nzLabel="December"></nz-option>
							</nz-select>
						</nz-form-control>
					</nz-form-item>
				</div>
				<div class="col-4">
					<nz-form-item>
						<nz-form-label nzRequired>Primary Premium Recipient</nz-form-label>
						<nz-form-control nzErrorTip="Please enter a value">
							<nz-select nzShowSearch nzAllowClear formControlName="primaryPremiumRecipient" [compareWith]="compareById">
								<nz-option *ngFor="let item of availableUnderwriters" [nzValue]="item" nzLabel="{{item.name}} ({{item.typeLabel}})"></nz-option>
							</nz-select>
						</nz-form-control>
					</nz-form-item>
					<nz-form-item>
						<nz-form-label>Policy Group</nz-form-label>
						<nz-form-control nzErrorTip="Please select a policy group">
							<nz-select nzShowSearch nzAllowClear formControlName="policyGroup" [compareWith]="compareById">
								<nz-option *ngFor="let item of availablePolicyGroups" [nzValue]="item" nzLabel="{{item.name}} ({{item.typeLabel}})"></nz-option>
							</nz-select>
						</nz-form-control>
					</nz-form-item>
					<nz-form-item>
						<nz-form-label>Employer</nz-form-label>
						<nz-form-control nzErrorTip="Please select an employer">
							<nz-select nzShowSearch nzAllowClear formControlName="employer" [compareWith]="compareById">
								<nz-option *ngFor="let item of availableEmployers" [nzValue]="item" nzLabel="{{item.name}}"></nz-option>
							</nz-select>
						</nz-form-control>
					</nz-form-item>
					<nz-form-item>
						<nz-form-control>
							<label nz-checkbox formControlName="enableBenefitPaymentFileGeneration">
								Enable Benefit Payment File Generation
							</label>
						</nz-form-control>
					</nz-form-item>
					<nz-form-item>
						<nz-form-label>Policy Number Prefix</nz-form-label>
						<nz-form-control nzErrorTip="Please enter a policy number prefix">
							<input nz-input formControlName="policyNumberPrefix" />
						</nz-form-control>
					</nz-form-item>
				</div>
			</div>
		</nz-tab>

		<!-- ─── Underwriting Rules ──────────────────────────────────────────── -->
		<nz-tab nzTitle="Underwriting Rules">
			<button class="float-end" nz-button nzType="dashed" (click)="addRule()">+ Add Rule</button>
			<nz-table #productRuleTable [nzData]="rules" nzSize="small" nzShowPagination="false" nzFrontPagination="false">
				<thead>
					<tr>
						<th>Rule Type</th>
						<th>Applied To</th>
						<th>Threshold</th>
						<th>Action</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let entry of productRuleTable.data">
						<td>{{ entry.ruleType }}</td>
						<td>{{ entry.appliedTo }}</td>
						<td>{{ entry.threshold }}</td>
						<td><button class="float-end" nz-button nzType="dashed" (click)="editRule(entry)">Edit</button></td>
					</tr>
				</tbody>
			</nz-table>
		</nz-tab>

		<!-- ─── Bank Accounts ──────────────────────────────────────────── -->
		<nz-tab nzTitle="Bank Accounts">
			<p>Where benefit payouts are payed from</p>
			<button class="float-end" nz-button nzType="dashed" (click)="addBankAccount()">+ Add Bank Account</button>
			<nz-table #productBankAccountTable [nzData]="bankAccounts" nzSize="small" nzShowPagination="false"  nzFrontPagination="false">
				<thead>
					<tr>
						<th>From Date</th>
						<th>To Date</th>
						<th>Bank</th>
						<th>Account Number</th>
						<th>Account Name</th>
						<th>Action</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let entry of productBankAccountTable.data">
						<td>{{ entry.fromDate | date }}</td>
						<td>{{ entry.toDate | date }}</td>
						<td>{{ entry.bank?.name }}</td>
						<td>{{ entry.accountNumber }}</td>
						<td>{{ entry.accountName }}</td>
						<td><button class="float-end" nz-button nzType="dashed" (click)="editBankAccount(entry)">Edit</button></td>
					</tr>
				</tbody>
			</nz-table>
		</nz-tab>

		<!-- ─── Offers ──────────────────────────────────────────────────────── -->
		<nz-tab nzTitle="Offers">
			<button class="float-end" nz-button nzType="dashed" (click)="addOffer()">+ Add Offer</button>
			<nz-table #productOfferTable [nzData]="offers" nzSize="small" [nzShowPagination]="false" [nzFrontPagination]="false">
				<thead>
					<tr>
						<th nzWidth="40px"></th>
						<th>Offer Name</th>
						<th>Description</th>
						<th>Action</th>
					</tr>
				</thead>
				<tbody>
					<ng-container *ngFor="let entry of productOfferTable.data">
						<!-- Main row -->
						<tr>
							<td [nzExpand]="entry._expanded" (nzExpandChange)="entry._expanded = $event"></td>
							<td>{{ entry.name }}</td>
							<td>{{ entry.description }}</td>
							<td>
								<button class="float-end" nz-button nzType="dashed" (click)="editOffer(entry)">Edit</button>
							</td>
						</tr>
						<!-- Expanded summary row -->
						<tr [nzExpand]="entry._expanded">
								<nz-tabset nzSize="small">

									<!-- Rules summary -->
									<nz-tab [nzTitle]="'Rules (' + (entry.rules?.length ?? 0) + ')'">
										<nz-table [nzData]="[0]" nzSize="small" nzShowPagination="false" nzFrontPagination="false" [nzBordered]="true">
											<thead>
												<tr>
													<th>Rule Type</th>
													<th>Applied To</th>
													<th>Threshold</th>
												</tr>
											</thead>
											<tbody>
												<tr *ngFor="let r of entry.rules ?? []">
													<td>{{ r.ruleType }}</td>
													<td>{{ r.appliedTo }}</td>
													<td>{{ r.threshold }}</td>
												</tr>
												<tr *ngIf="(entry.rules ?? []).length === 0">
													<td colspan="3" style="text-align:center; color:#999;">No rules</td>
												</tr>
											</tbody>
										</nz-table>
									</nz-tab>

									<!-- Lines summary -->
									<nz-tab [nzTitle]="'Lines (' + (entry.lines?.length ?? 0) + ')'">
										<ng-container *ngFor="let l of entry.lines ?? []">
											<!-- Line header -->
											<div style="display:flex; align-items:center; gap:8px; padding: 8px 0 4px;">
												<strong>{{ l.name }}</strong>
												<span *ngIf="l.description" style="color:#8c8c8c;">— {{ l.description }}</span>
												<nz-tag *ngIf="l.compulsory" nzColor="blue">Compulsory</nz-tag>
											</div>
											<!-- Details table for this line -->
											<nz-table
												[nzData]="[0]"
												nzSize="small"
												nzShowPagination="false"
												 nzFrontPagination="false"
												[nzBordered]="true"
												class="mb-3">
												<thead>
													<tr>
														<th>From Date</th>
														<th>To Date</th>
														<th>Premium Type</th>
														<th>Premium (R)</th>
														<th>Benefit Type</th>
														<th>Benefit (R)</th>
														<th>New Only</th>
														<th>Commissions</th>
													</tr>
												</thead>
												<tbody>
													<tr *ngFor="let d of l.details ?? []">
														<td>{{ d.fromDate | date:'yyyy-MM-dd' }}</td>
														<td>{{ d.toDate | date:'yyyy-MM-dd' }}</td>
														<td>{{ d.premiumType }}</td>
														<td>{{ d.premiumAmount | number:'1.2-2' }}</td>
														<td>{{ d.benefitType }}</td>
														<td>{{ d.benefitAmount | number:'1.2-2' }}</td>
														<td>
															<span nz-icon [nzType]="d.appliesOnlyToNewPolicies ? 'check-circle' : 'minus-circle'" [style.color]="d.appliesOnlyToNewPolicies ? '#52c41a' : '#d9d9d9'"></span>
														</td>
														<td>
															<div *ngFor="let c of d.commissions ?? []" style="line-height:1.8;">
																{{ c.recipient.name }} ({{ c.recipient.type }})
																<span class="float-end">
																	<nz-tag nzColor="default">{{ c.commissionType }}</nz-tag>
																	<strong>{{ c.commissionAmount | number:'1.2-2' }}</strong>
																</span>
															</div>
															<span *ngIf="(d.commissions ?? []).length === 0" style="color:#bfbfbf;">—</span>
														</td>
													</tr>
													<tr *ngIf="(l.details ?? []).length === 0">
														<td colspan="8" style="text-align:center; color:#999;">No details</td>
													</tr>
												</tbody>
											</nz-table>
										</ng-container>
										<nz-alert *ngIf="(entry.lines ?? []).length === 0" nzType="info" nzMessage="No lines" class="mt-1"></nz-alert>
									</nz-tab>

									<!-- Benefit Splits summary -->
									<nz-tab [nzTitle]="'Benefit Splits (' + (entry.benefitSplits?.length ?? 0) + ')'">
										<nz-table [nzData]="[0]" nzSize="small" nzShowPagination="false" nzFrontPagination="false" [nzBordered]="true">
											<thead>
												<tr>
													<th>Applied To</th>
													<th>Age From</th>
													<th>Age To</th>
													<th>Benefit (R)</th>
												</tr>
											</thead>
											<tbody>
												<tr *ngFor="let b of entry.benefitSplits ?? []">
													<td>{{ b.appliedTo }}</td>
													<td>{{ b.fromAge }}</td>
													<td>{{ b.toAge }}</td>
													<td>{{ b.benefitAmount | number:'1.2-2' }}</td>
												</tr>
												<tr *ngIf="(entry.benefitSplits ?? []).length === 0">
													<td colspan="4" style="text-align:center; color:#999;">No benefit splits</td>
												</tr>
											</tbody>
										</nz-table>
									</nz-tab>
									<!-- Benefit Rule  -->
									<nz-tab [nzTitle]="'Benefit Rule (' + (entry.benefitRules?.length ?? 0) + ')'">
										<nz-table [nzData]="[0]" nzSize="small" nzShowPagination="false"  nzFrontPagination="false" [nzBordered]="true">
											<thead>
												<tr>
													<th>From</th>
													<th>To</th>
													<th>Benefit Percentage</th>
												</tr>
											</thead>
											<tbody>
												<tr *ngFor="let b of entry.benefitRules ?? []">
													<td>{{ b.from }}</td>
													<td>{{ b.to }}</td>
													<td>{{ b.percentage | number:'1.2-2' }}</td>
												</tr>
												<tr *ngIf="(entry.benefitRules ?? []).length === 0">
													<td colspan="4" style="text-align:center; color:#999;">No benefit Rule</td>
												</tr>
											</tbody>
										</nz-table>
									</nz-tab>
								</nz-tabset>
						</tr>
					</ng-container>
				</tbody>
			</nz-table>
		</nz-tab>

		<!-- ─── Extended Cover ──────────────────────────────────────────────── -->
		<nz-tab nzTitle="Extended Cover">
			<button class="float-end" nz-button nzType="dashed" (click)="addExtended()">+ Add Extended</button>
			<nz-table #productExtendedTable [nzData]="extended" nzSize="small" nzShowPagination="false" nzFrontPagination="false">
				<thead>
					<tr>
						<th nzWidth="40px"></th>
						<th>Name</th>
						<th>Description</th>
						<th>Action</th>
					</tr>
				</thead>
				<tbody>
					<ng-container *ngFor="let entry of productExtendedTable.data">
						<!-- Main row -->
						<tr>
							<td [nzExpand]="entry._expanded" (nzExpandChange)="entry._expanded = $event"></td>
							<td>{{ entry.name }}</td>
							<td>{{ entry.description }}</td>
							<td>
								<button class="float-end" nz-button nzType="dashed" (click)="editExtended(entry)">Edit</button>
							</td>
						</tr>
						<!-- Expanded detail row -->
						<tr [nzExpand]="entry._expanded">
							<nz-table
								[nzData]="[0]"
								nzSize="small"
								nzShowPagination="false"
								 nzFrontPagination="false"
								[nzBordered]="true">
								<thead>
									<tr>
										<th>From Date</th>
										<th>To Date</th>
										<th>Age From</th>
										<th>Age To</th>
										<th>Relation</th>
										<th>Premium Type</th>
										<th>Premium (R)</th>
										<th>Benefit (R)</th>
										<th>Commissions</th>
									</tr>
								</thead>
								<tbody>
									<tr *ngFor="let detail of entry.details ?? []">
										<td>{{ detail.fromDate | date:'yyyy-MM-dd' }}</td>
										<td>{{ detail.toDate | date:'yyyy-MM-dd' }}</td>
										<td>{{ detail.fromAge }}</td>
										<td>{{ detail.toAge }}</td>
										<td>{{ detail.relationToMainMember }}</td>
										<td>{{ detail.premiumType }}</td>
										<td>{{ detail.premiumAmount | number:'1.2-2' }}</td>
										<td>{{ detail.benefitAmount | number:'1.2-2' }}</td>
										<td>
											<div *ngFor="let c of detail.commissions ?? []" style="line-height:1.8;">
												{{ c.recipient.name }} ({{ c.recipient.type }})
												<span class="float-end">
													<nz-tag nzColor="default">{{ c.commissionType }}</nz-tag>
													<strong >{{ c.commissionAmount | number:'1.2-2' }}</strong>
												</span>
											</div>
											<span *ngIf="(detail.commissions ?? []).length === 0" style="color:#bfbfbf;">—</span>
										</td>
									</tr>
									<tr *ngIf="(entry.details ?? []).length === 0">
										<td colspan="9" style="text-align: center; color: #999;">No rate periods defined</td>
									</tr>
								</tbody>
							</nz-table>
						</tr>
					</ng-container>
				</tbody>
			</nz-table>
		</nz-tab>
		<nz-tab *ngIf="product?.id" nzTitle="Workflow" (nzSelect)="openClaimWorkflow()">
		</nz-tab>
		<nz-tab *ngIf="product?.id" nzTitle="Payment Sent Communication">
			<p class="alert alert-info">Communication sent when payment has been loaded with the bank </p>
			<nz-card nzTitle="Configure Email" class="compose-email-card" [formGroup]="paymentSentCommunication">
					<!-- From -->
					<nz-form-item>
						<nz-form-label [nzSpan]="4" nzRequired>
							<app-invalid-form-indicator [form]="paymentSentCommunication" field="name" class="me-3"></app-invalid-form-indicator>
							Name
						</nz-form-label>
						<nz-form-control [nzSpan]="20">
							<input nz-input formControlName="name" placeholder="Communication Name" />
						</nz-form-control>
					</nz-form-item>
					<!-- From -->
					<nz-form-item>
						<nz-form-label [nzSpan]="4" nzRequired>
							<app-invalid-form-indicator [form]="paymentSentCommunication" field="emailFrom" class="me-3"></app-invalid-form-indicator>
							From
						</nz-form-label>
						<nz-form-control [nzSpan]="20">
							<input nz-input formControlName="emailFrom" placeholder="your@email.com"  />
						</nz-form-control>
					</nz-form-item>

					<!-- To -->
					<nz-form-item>
						<nz-form-label [nzSpan]="4">
							<app-invalid-form-indicator [form]="paymentSentCommunication" field="emailTo" class="me-3"></app-invalid-form-indicator>
							To
						</nz-form-label>
						<nz-form-control [nzSpan]="20">
							<input nz-input formControlName="emailTo" placeholder="Recipient email(s)"  />
						</nz-form-control>
					</nz-form-item>

					<!-- Cc -->
					<nz-form-item>
						<nz-form-label [nzSpan]="4">
							<app-invalid-form-indicator [form]="paymentSentCommunication" field="emailCc" class="me-3"></app-invalid-form-indicator>
							CC
						</nz-form-label>
						<nz-form-control [nzSpan]="20">
							<input nz-input formControlName="emailCc" placeholder="CC email(s)"  />
						</nz-form-control>
					</nz-form-item>

					<!-- Bcc -->
					<nz-form-item>
						<nz-form-label [nzSpan]="4">
							<app-invalid-form-indicator [form]="paymentSentCommunication" field="emailBcc" class="me-3"></app-invalid-form-indicator>
							BCC
						</nz-form-label>
						<nz-form-control [nzSpan]="20">
							<input nz-input formControlName="emailBcc" placeholder="BCC email(s)"  />
						</nz-form-control>
					</nz-form-item>

					<!-- Subject -->
					<nz-form-item>
						<nz-form-label [nzSpan]="4" nzRequired>
							<app-invalid-form-indicator [form]="paymentSentCommunication" field="emailSubject" class="me-3"></app-invalid-form-indicator>
							Subject
						</nz-form-label>
						<nz-form-control [nzSpan]="20">
							<input nz-input formControlName="emailSubject" placeholder="Email subject"  />
						</nz-form-control>
					</nz-form-item>

					<!-- Body -->
					<nz-form-item>
						<nz-form-label [nzSpan]="4" nzRequired>
							<app-invalid-form-indicator [form]="paymentSentCommunication" field="emailBody" class="me-3"></app-invalid-form-indicator>
							Body
						</nz-form-label>
						<nz-form-control [nzSpan]="20">
							<app-email-body-editor *ngIf="emailPlaceholders" [placeholders]="emailPlaceholders" formControlName="emailBody" [readOnly]="false"></app-email-body-editor>
							<span *ngIf="!emailPlaceholders">Loading...</span>
						</nz-form-control>
					</nz-form-item>


					<nz-form-item>
						<nz-form-label [nzSpan]="4" nzRequired>
							<app-invalid-form-indicator [form]="paymentSentCommunication" field="emailBody" class="me-3"></app-invalid-form-indicator>
							Attachments
						</nz-form-label>
						<nz-form-control [nzSpan]="20">
							<nz-table [nzData]="product?.paymentSentCommunication?.attachments??[]" [nzShowPagination]="false" [nzSize]="'small'">
								<thead>
									<tr>
										<th>Attachment</th>
									</tr>
								</thead>
								<tbody>
									<tr *ngFor="let attachment of product?.paymentSentCommunication?.attachments??[]">
										<td>
											{{attachment.name}}
										</td>
									</tr>
								</tbody>
							</nz-table>
						</nz-form-control>
					</nz-form-item>
					<!-- Attachments -->
					<nz-form-item>
						<nz-form-label [nzSpan]="4">
							Attachments
						</nz-form-label>
						<nz-form-control [nzSpan]="20">
							<nz-upload [nzMultiple]="true" [nzFileList]="paymentSentAttachmentsNew" [nzCustomRequest]="paymentSentCustomUpload">
								<button nz-button>
									<i nz-icon nzType="upload"></i>
									Select File
								</button>
							</nz-upload>
						</nz-form-control>
					</nz-form-item>
			</nz-card>
		</nz-tab>
	</nz-tabset>
	<div [hidden]="selectedTab != 5">
		<router-outlet ></router-outlet>
	</div>
	<button *ngIf="selectedTab != 5 && !form.invalid" nz-button nzType="primary" (click)="save()" class="mt-3">
		Save Product Configuration
	</button>
	<button *ngIf="selectedTab != 5 && form.invalid" nz-button class="mt-3">
		<app-invalid-form-indicator [form]="form"></app-invalid-form-indicator>
		<span class="ms-3">Save Product Configuration</span>
	</button>
</form>
<!--


<br/>
[{{getAllErrors(form)|json}}] -->
